import React from "react";
import { Col, Row } from "react-bootstrap";
import { Query } from "react-apollo";

import { formatNumber } from "../../generic";
import { getComptes } from "../../../api/queries/comptes.queries";
import { useAuthState } from "../../Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";

function CashBar(props) {
  const authContext = useAuthState(); //read user de

  const { userDetails = {} } = authContext;
  const { id: utilisateurId, login, email, token } = userDetails;

  if (!utilisateurId) return;

  return (
    <div id="cashBar">
      <Row cols={2}>
        <Col xs={12} sm={6}>
          {" "}
          <span className="title">Solde actuel</span>
        </Col>

        <Col xs={12}>
          <span className="solde">
            <Query query={getComptes} variables={{ utilisateurId }}>
              {({ loading, error, data = {}, refetch }) => {
                if (loading)
                  return (
                    <FontAwesomeIcon
                      icon={faRefresh}
                      size="sm"
                      className="fa-spin"
                    />
                  );

                if (error)
                  return (
                    <FontAwesomeIcon
                      icon={faRefresh}
                      size="sm"
                      className="fa-spin"
                    />
                  );

                const { getComptes = [] } = data;

                let totalBalance = 0;

                getComptes.forEach(
                  ({ active, balance }) => active && (totalBalance += balance)
                );

                return `${formatNumber(totalBalance, "€")}`;
              }}
            </Query>
          </span>{" "}
        </Col>
      </Row>
    </div>
  );
}
export default CashBar;
